import BaseTheme from '../base';

export default {
  ...BaseTheme.Fonts,
  xxxs: '0.8rem',
  xxs: '1rem',
  xs: '1.2rem',
  s: '1.4rem',
  m: '1.6rem',
  l: '1.8rem',
  xl: '2rem',
  xxl: '2.2rem',
  xxxl: '2.6rem',
  xxxxl: '3.4rem',
  xxxxxl: '4rem',
  xxxxxxl: '5.6rem',
  xxxxxxxl: '6.4rem',
  xxxxxxxxl: '7.6rem',
  light: 'Gotham Light',
  bold: 'Gotham Bold',
  title: 'Gotham Medium'
};
